import React from 'react';
import {
  HeaderWrapper,
  HeaderInner,
  HeaderTitle,
  HeaderBody,
  ContentWrapper,
  ScrollButton,
  ScrollText,
  ScrollWrapper,
} from './Header.styled';
import Video from '../Video';

const Header = () => {
  const scrollDown = () => {
    if (typeof window !== 'undefined') {
      //eslint-disable-line valid-typeof
      const top = window.innerHeight - 10;
      window.scroll({ top, behavior: 'smooth' });
    }
  };

  return (
    <HeaderWrapper id="facilitytour-header">
      <HeaderInner>
        <ContentWrapper>
          <HeaderTitle className="section-title">
            The great indoors.
          </HeaderTitle>
          <HeaderBody className="section-header">
            Every Clayton Built&reg; home is constructed inside a
            state-of-the-art, climate-controlled facility, away from the
            elements. It’s a smarter way to build that fosters innovation and
            ensures every aspect of your home is of the highest quality.
          </HeaderBody>
        </ContentWrapper>
      </HeaderInner>
      {/* swapped */}
      <Video
        src={
          'https://www.claytonhomes.com/videos/dreamtoreality/facilityTour/cover-video.mp4'
        }
        poster={'/public-assets/images/facility-tour/cover-poster.png'}
        scrim
      />
      <ScrollWrapper onClick={scrollDown}>
        <ScrollText>SCROLL</ScrollText>
        <ScrollButton />
      </ScrollWrapper>
    </HeaderWrapper>
  );
};

export default Header;
